import script from "./LivviaStrip.vue?vue&type=script&setup=true&lang=ts"
export * from "./LivviaStrip.vue?vue&type=script&setup=true&lang=ts"

import "./LivviaStrip.vue?vue&type=style&index=0&id=bc2b6c4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc2b6c4e"]])

export default __exports__